// extracted by mini-css-extract-plugin
export default {"sectionContainer":"SectionContainer_sectionContainer__vi--G"};